export class Config {
  public static API_URL = process.env.REACT_APP_API_URL;
  public static KAKAO_MAP_APP_KEY = process.env.REACT_APP_KAKAO_MAP_APP_KEY;
}
